import React from "react"
import { wordTitleCase } from "helpers/data-formatters"

const TitleText = cell => {
  return cell.value || ""
}

export { TitleText }
